<script>
  import { slide, fade } from 'svelte/transition';

  export let type = 'input';
  export let placeholder = '';
  export let label = '';
  export let value = '';
  export let icon = false;
  export let error = false;
  export let options = [];

  let open = false;

  $: selectedLabel = value ? value : options[0];

  function handleOption(e) {
    open = false;

    value = e.target.value;
  }
</script>

<div class="form-field" class:form-field--error={error}>
  <div class="form-field__box">
    <span class="form-field__label text-small">{label}</span>
    <i class={`form-field__icon isax isax-${icon}`} />

    {#if type == 'select'}
      <select
        class="form-field__input"
        on:click={() => {
          open = !open;
        }}
        value={selectedLabel}
      >
        {#each options as option}
          <option value={option} on:click={handleOption}>
            {option}
          </option>
        {/each}</select
      >
    {:else}
      <input class="form-field__input" type="text" bind:value {placeholder} />
    {/if}

    {#if error}
      <span class="form-field__error text-small" transition:fade
        >{error[0]}</span
      >
    {/if}
  </div>
</div>

<style lang="scss">
  .form-field {
    position: relative;

    &__label {
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;

      display: block;
      color: var(--grey);
    }

    &__box {
      position: relative;
    }

    &__icon {
      position: absolute;

      top: 50%;
      left: 0;
    }

    &__input {
      color: rgb(var(--white));

      width: 100%;
      padding: 3rem 3rem 1.6rem;
      border-bottom: 1px solid rgba(var(--white), 0.1);

      .form-field--error & {
        border-bottom-color: var(--red);
      }

      &:focus {
        outline: none;

        border-bottom-color: rgb(var(--white));
      }
    }

    &__error {
      position: absolute;
      top: 50%;
      right: 0;

      color: var(--red);
    }

    &__options {
      position: absolute;
      z-index: 10;
      top: 100%;
      left: 0;
      right: 0;

      padding: 1rem;
      max-height: 20rem;

      color: rgb(var(--white));
      border-radius: 0 0 0.5rem 0.5rem;
      background-color: var(--royal);

      box-shadow: 0 1rem 1rem rgba(var(--black), 0.5);

      li {
        margin: 0.5rem 0;
      }

      &-item {
        padding: 0.5rem 0;
        display: block;
        width: 100%;
      }
    }

    select {
      /* for Firefox */
      -moz-appearance: none;
      /* for Safari, Chrome, Opera */
      -webkit-appearance: none;
    }

    /* for IE10 */
    select::-ms-expand {
      display: none;
    }

    select > option {
      color: var(--royal);
    }
  }
</style>
